export default "__VITE_PUBLIC_ASSET__54ba5589__"